import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const ComingSoonPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: routesUrl.comingSoon,
      component: React.lazy(() => import('./ComingSoonPage')),
    },
  ],
};

export default ComingSoonPageConfig;
